import { render, staticRenderFns } from "./TasksCounter.vue?vue&type=template&id=43e332bc&scoped=true"
import script from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TasksCounter.vue?vue&type=style&index=0&id=43e332bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e332bc",
  null
  
)

export default component.exports